<template>
  <div class="thoughtParty">
    <div class="body">
      <!-- <SzztkHeader /> -->
      <div class="top_nav w1000" style="display:none">
        <a href="http://www.people.cn/" target="_blank"><img src="../../assets/image/new-szztk/cfsl/logo_rmw.png"></a><span></span>
      </div>

      <div class="banner">

      </div>
      <div class="w1000 p1_con">
        <ul class="list list0">
          <li v-for="item,index in listData" :key="index"><span>
              <a :href="item.path" target="_blank">
                <img :src="item.img_path" width="364" height="241"></a> </span>
            <div>
              <strong>{{item.title}}</strong>
              <p>{{item.sub_text}}

                <a :href="item.path" target="_blank">
                  <font color="#000080">【详细】</font>
                </a>
              </p>

            </div>
          </li>
        </ul>

      </div>

    </div>
  </div>
</template>

<script>
// import SzztkHeader from "../../components/szztkHeader.vue"

import { mapActions } from "vuex"

export default {
  name: "xfrw",
  components: {
    // SzztkHeader,
  },
  data () {
    return {
      listData: [
        {
          title: "习近平在上海",
          sub_text: "《习近平在上海》是反映习近平总书记成长历程系列采访实录的第八部，反映的主要是习近平同志2007年3月至10月任上海市委书记的领导工作历程。",
          img_path: require("../../assets/image/new-szztk/ylzl/sh.png"),
          path: "http://cpc.people.com.cn/GB/67481/440992/index.html",
        },
        {
          title: "习近平在浙江",
          sub_text: "《习近平在浙江》反映的主要是习近平同志2002年10月至2007年3月任浙江省委副书记、代省长和省委书记的领导工作历程。",
          img_path: require("../../assets/image/new-szztk/ylzl/zj.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/436924/index.html",

        },
        {
          title: "习近平在福建",
          sub_text: "《习近平在福建》通过对当年班子成员、身边工作人员、专家学者、记者等人的访谈，还原了习近平同志在福建省委省政府工作期间大刀阔斧、超前谋划、开拓创新的领导风范，展现了他率先带头、亲身示范、勇于担当的工作作风，彰显了他心系基层、心系群众、心系民生的赤诚情怀。",
          img_path: require("../../assets/image/new-szztk/ylzl/fj.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441135/index.html",


        },
        {
          title: "习近平在福州",
          sub_text: "《习近平在福州》是记录习近平总书记成长历程的系列采访实录的第五部。1990年4月，习近平同志从闽东的宁德地委书记调任省会城市福州的市委书记，在这里工作了整整六年。",
          img_path: require("../../assets/image/new-szztk/ylzl/fz.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441136/index.html",


        },
        {
          title: "习近平在宁德",
          sub_text: "《习近平在宁德》以讲述者口述记录的形式，再现了习近平同志成长历程中的一个阶段。19篇采访实录，从不同角度回忆了习近平同志在宁德的工作经历，生动讲述了三进下党、“四下基层”、搞“经济大合唱”、颁布“公务接待12条”、整治干部违规私建住宅等攻坚克难的故事。",
          img_path: require("../../assets/image/new-szztk/ylzl/nd.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441137/index.html",


        },
        {
          title: "习近平在厦门",
          sub_text: "《习近平在厦门》通过采访习近平同志在厦门任市委常委、常务副市长期间与他有过直接接触的同事、干部群众等人，真实地还原和再现了习近平同志在厦门的从政轨迹和领导风范。",
          img_path: require("../../assets/image/new-szztk/ylzl/xm.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441138/index.html",


        },

        {
          title: "习近平在正定",
          sub_text: "1982年3月至1985年5月，习近平同志任河北省正定县委副书记和书记，在正定工作了三年多。习近平同志与干部群众打成一片，走遍了全县每一个村。",
          img_path: require("../../assets/image/new-szztk/ylzl/zd.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441139/index.html",


        },
        {
          title: "习近平的七年知青岁月",
          sub_text: "1969年年初，15岁的习近平来到黄土高原的延川县文安驿公社梁家河村，直到1975年10月离开。这七年，他在这片黄土地上同乡亲们打成一片，一起挑粪拉煤，一起拦河打坝，一起建沼气池，一起吃玉米“团子”。",
          img_path: require("../../assets/image/new-szztk/ylzl/zqsy.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",


        },

      ]
    };
  },
  methods: {
    ...mapActions(['goAppsDetailsBeforeLogin',]),
    toSzyskDetail (item) {
      let that = this;
      // that.goAppsDetailsBeforeLogin().then(() => {
        window.open(item.res_path, '_blank')
      // })
    },
  }

};
</script>

<style lang="less"  scoped>
.banner {
  height: 500px;
  background: url('../../assets/image/new-szztk/ylzl/header-banner.jpg')
    no-repeat top center;
  padding-top: 310px;
}
/* CSS Document */
body {
  padding: 0;
  margin: 0;
  color: #000000;
  text-align: center;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}

div {
  margin: 0 auto;
  text-align: left;
}
a:link,
a:visited {
  color: #000;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

img {
  border: none;
}

ol,
ul,
li {
  list-style: none;
}

em,
i {
  font-style: normal;
}

.clear {
  clear: both;
}

/* clearfix */
.clearfix:before,
.clearfix:after {
  content: '';
  display: table;
}

.clearfix:after {
  clear: both;
  overflow: hidden;
}

.clearfix {
  zoom: 1;
}

/*other*/
.fl {
  float: left;
}

.fr {
  float: right;
}

.m0 {
  margin: 0 auto;
}

.m10 {
  margin: 10px auto;
}

.mb10 {
  margin-bottom: 10px;
}

.mb15 {
  margin-bottom: 15px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt5 {
  margin-top: 5px;
}

.mt10 {
  margin-top: 10px;
}

.mt20 {
  margin-top: 20px;
}

.mt12 {
  margin-top: 12px;
}

.mt15 {
  margin-top: 15px;
}

.mt17 {
  margin-top: 17px;
}

.ml5 {
  margin-left: 5px;
}

.ml10 {
  margin-left: 10px;
}

.ml15 {
  margin-left: 15px;
}

.ml25 {
  margin-left: 25px;
}

.mr5 {
  margin-right: 5px;
}

.mr10 {
  margin-right: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.p5 {
  padding: 5px 0;
}

.p3 {
  padding: 3px 0;
}

.p0 {
  padding: 0;
}

.p10 {
  padding: 10px;
}

.pb10 {
  padding-bottom: 10px;
}

.pb15 {
  padding-bottom: 15px;
}

.pb1 {
  border-bottom: 1px;
}

.bd1 {
  border: 1px solid #dad0ae;
}

.w1000 {
  width: 1000px;
}

.w980 {
  width: 980px;
}

.w978 {
  width: 978px;
  border: 1px solid #ecddac;
  background: #fff;
}

.w960 {
  width: 960px;
}

.w100 {
  width: 100%;
}

.f14 {
  font-size: 14px;
}

.am2 a {
  margin: 0 2px;
}

.am3 a {
  margin: 0 3px;
}

.am5 a {
  margin: 0 5px;
}

.duan {
  width: 100%;
  height: 8px;
}

.t_c {
  text-align: center;
}

.t_l {
  text-align: left;
}

.t_r {
  text-align: right;
}

.w300 {
  width: 300px;
}

.w360 {
  width: 360px;
}

.list_14 li {
  /* background: url(images/dot.gif) no-repeat 5px 12px; */
  padding-left: 15px;
  font-size: 14px;
  line-height: 28px;
}

.list_12 li {
  /* background: url(images/dot2.gif) no-repeat 5px 14px; */
  padding-left: 15px;
  line-height: 28px;
}

.list_12 li,
.list_14 li,
.list_14 li a:link,
.list_14 li a:hover,
.list_14 li a:visited,
.list_12 li a:link,
.list_12 li a:hover,
.list_12 li a:visited {
  color: #033266;
}

.l_h26 {
  line-height: 26px;
}

.l_h24 {
  line-height: 24px;
}

.l_h22 {
  line-height: 22px;
}

.o_h {
  overflow: hidden;
}

.white,
.white a:link,
.white a:hover,
.white a:visited {
  color: #fff;
}

.blue,
.blue a:link,
.blue a:hover,
.blue a:visited {
  color: #6997c7;
}

.red,
.red a:link,
.red a:hover,
.red a:visited {
  color: #cc0000;
}

/*top nav*/
.top_nav {
  width: 989px;
  height: 35px;
}

.top_nav img {
  float: left;
  vertical-align: middle;
  margin: 0 20px auto 20px;
}

.top_nav span {
  float: right;
  margin-right: 10px;
  line-height: 35px;
  color: #565656;
}

.top_nav span a {
  color: #565656;
  padding: 0 6px;
}

.top_nav b {
  float: left;
  font-size: 18px;
  color: #be140b;
  font-family: \9ed41\4f53;
  margin-left: 10px;
}

/*p1*/
.p1_con {
  overflow: hidden;
}

.p1_con h2 {
  margin: 25px auto;
}

.p1_con h2 i {
  font-size: 36px;
  color: #cc5145;
  padding-left: 50px;
  height: 44px;
  line-height: 44px;
}

.p1_con ul li {
  padding: 28px 0 60px 0;
  overflow: hidden;
  border-bottom: 1px solid #d1d1d1;
  margin-top: 50px;
}

.p1_con ul li:last-child {
  border: none;
}

.p1_con ul li span {
  float: left;
  width: 364px;
  position: relative;
  margin-right: 30px;
  clear: both;
}

.p1_con ul li span em {
  display: block;
  width: 64px;
  height: 43px;
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  font-size: 18px;
  line-height: 36px;
  text-align: center;
}

.p1_con ul li div div {
  height: unset;
  border-bottom: none;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}
.p1_con ul li div div a {
  color: #0537b6 !important;
  text-decoration: none;
  font-size: 16px;
  line-height: 28px;
}

.p1_con ul li div strong,
.p1_con ul li div b,
.p1_con ul li div p {
  display: block;
}

.p1_con ul li div strong {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.p1_con ul li div b {
  line-height: 55px;
  color: #787878;
  font-size: 16px;
}

.p1_con ul li div p {
  line-height: 28px;
  font-size: 14px;
}

.p2_con {
  width: 1030px;
  padding: 15px 0;
}

.p2_con img {
  float: left;
  margin: 15px;
}

.p3_con {
  padding: 20px 0;
  overflow: hidden;
  font-size: 14px;
}

.erwm_right {
  position: fixed;
  _position: absolute;
  background-position: 0 -40px;
  display: block;
  width: 88px;
  right: 13px;
  _right: -52px;
  bottom: 90px;
}

.erwm_right ul li {
  width: 86px;
  height: 73px;
  border: 1px solid #ece3db;
  background: #eeebe8;
  text-align: center;
  font-size: 18px;
  line-height: 73px;
  color: #856851;
  margin: 2px auto;
}

.erwm_right ul li:hover {
  background: #c13b3b;
  color: #fff;
}

.erwm_right span {
  width: 86px;
  padding: 10px 0;
  border: 1px solid #ece3db;
  background: #eeebe8;
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  color: #856851;
  display: block;
  overflow: hidden;
  margin: 2px auto;
}

.erwm_right span img {
  display: block;
  margin: 5px auto 15px auto;
}

.go_top {
  position: fixed;
  _position: absolute;
  background-position: 0 -40px;
  display: block;
  width: 88px;
  height: 75px;
  right: 13px;
  _right: -52px;
  bottom: 28px;
  filter: alpha(opacity=80);
  border-top: 2px solid #fff;
}

.go_top:hover {
  filter: alpha(opacity=100);
}

.tc_con {
  width: 1010px;
}

.tc_con3 {
  overflow-y: visible;
  overflow-x: hidden;
  height: 90%;
  width: 1030px;
}

.tc_con ul {
  margin: 60px auto;
}

.tc_con ul li {
  float: left;
  margin: 5px 0 0 5px;
  width: 331px;
  height: 63px;
  background: #e9d3a9;
  color: #704c2f;
}

.tc_con ul li:hover {
  background: #fff1d5;
}

.tc_con ul li a {
  color: #704c2f;
}

.tc_con ul li b {
  font-size: 16px;
  line-height: 63px;
  float: left;
  padding: 0 15px 0 45px;
}

.tc_con ul li p {
  font-size: 14px;
  line-height: 63px;
}

.tc_con ul li p.two em {
  display: block;
  line-height: 20px;
}

.tc_con ul li p.two {
  line-height: 20px;
  padding-top: 10px;
}

.tc_con {
  position: fixed;
  bottom: 10px;
  left: 50%;
  margin-left: -510px;
  z-index: 2;
  display: none;
}

.close {
  position: absolute;
  top: 0;
  right: 0px;
  width: 53px;
  height: 51px;
  cursor: pointer;
}

.tc_bg {
  /* background: url(images/bg2.png); */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  display: none;
  text-align: center;
}

.tc_a li {
  position: relative;
  cursor: pointer;
}

.more,
.more1,
.more2,
.more3 {
  text-align: center;
  padding: 20px 0;
  overflow: hidden;
  clear: both;
  font-size: 20px;
  /* background: url(images/more.png) no-repeat top center; */
  width: 89px;
  height: 40px;
  margin: 0 auto;
}

.list,
.list1,
.list2,
.list3 {
  overflow: hidden;
}

/*======= copyright========*/
.copyright {
  margin: 0px auto;
  width: 100%;
  font-size: 12px;
  color: #000000;
  text-align: center;
  padding: 20px 0;
  line-height: 180%;
  clear: both;
}

#copyright {
  clear: both;
  margin: 5px auto;
  padding-top: 10px;
  width: 980px;
  height: auto;
  color: #2a3084;
  text-align: center;
}

#copyright p {
  margin: 0 0 2px 0;
  text-align: center;
}

#copyright a {
  color: #2a3084;
}

#copyright p.p1 {
  margin: 15px auto;
  width: 530px;
}

#copyright p.p2 {
  margin: 8px 0 0 0;
}
.bza {
  width: 720px;
  font-size: 14px;
  background: url('../../assets/image/new-szztk/cfsl/bza.png') no-repeat top
    left;
  min-height: 115px;
  color: #305582;
}
.bza p {
  width: 720px;
  padding-left: 70px;
  line-height: 30px;
  text-indent: 2em;
}
.list p {
  text-indent: 2em;
}
</style>
